import { RequestHelper } from "../Helpers/RequestHelper.js";

export class PmLogApi {
    constructor(config) {
        this.config = config;
    }

    getRootURL() {
        return "https://log.dev.pixelmotiondemo.com/";
    }

    getURL() {
        return this.getRootURL() + "api";
    }

    send(eventData, log_type, successCallback, errorCallback) {
        let route = this.getURL() + "/pmlog/" + log_type;
        if (!eventData) {
            console.error("eventData null on send function");
            return;
        }
        eventData.site_token = this.config.config.accountId;
        eventData.log_type = log_type;
        eventData.source_path = window.location.pathname;
        RequestHelper.ajax("POST", route, eventData, successCallback, errorCallback);
    }
}